export const MONITORING_DATA_TYPE = {
    SENSOR: "sensor",  // 传感器
    MONITOR_OBJ: "mobject",  // 监测对象
}